var map = {
	"./hero/icons": [
		7531,
		531
	],
	"./joyland/icons": [
		5355,
		355
	],
	"./little-donkey/icons": [
		1465,
		465
	],
	"./luca/icons": [
		5659,
		659
	],
	"./magnolia-point/icons": [
		8106,
		106
	],
	"./pihakis/icons": [
		1172,
		172
	],
	"./psito/icons": [
		7092,
		92
	],
	"./rodney-scotts/icons": [
		4797,
		797
	],
	"./tasty-town/icons": [
		6807,
		807
	],
	"./valley-post/icons": [
		1019,
		19
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5856;
module.exports = webpackAsyncContext;